module.exports = __webpack_public_path__ + "images/logo/nikkei-c5ad086a.svg";